import { useCallback, useEffect, useState } from 'react';
import { ClassVisitorRecord } from '../mocks/classVisitors';
import { classVisitorService } from '../services/classVisitor.service';

const mergeVisitors = (classId: string, visitors: ClassVisitorRecord[]) => {
  const visitorsByContact = new Map<string, ClassVisitorRecord>();

  visitors.forEach((visitor) => {
    const key = `${visitor.name.trim().toLowerCase()}|${visitor.whatsapp.trim() || visitor.id}`;
    const existing = visitorsByContact.get(key);

    if (!existing) {
      visitorsByContact.set(key, visitor);
      return;
    }

    visitorsByContact.set(key, {
      ...existing,
      classId,
      convertedToStudentId: existing.convertedToStudentId ?? visitor.convertedToStudentId,
      visits: [...existing.visits, ...visitor.visits],
    });
  });

  return Array.from(visitorsByContact.values());
};

export const useClassTrimesterVisitors = (classId?: string | null, lessonIds: string[] = [], trimesterId?: string | null) => {
  const [classVisitors, setClassVisitors] = useState<ClassVisitorRecord[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const loadVisitors = useCallback(async () => {
    if (!classId || !trimesterId || lessonIds.length === 0) {
      setClassVisitors([]);
      return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const visitorsByLesson = await Promise.all(
        lessonIds.map((lessonId) => classVisitorService.listByLesson(classId, lessonId, trimesterId))
      );

      setClassVisitors(mergeVisitors(classId, visitorsByLesson.flat()));
    } catch (loadError) {
      setError(loadError instanceof Error ? loadError.message : 'Nao foi possivel carregar os visitantes.');
    } finally {
      setIsLoading(false);
    }
  }, [classId, lessonIds, trimesterId]);

  useEffect(() => {
    loadVisitors();
  }, [loadVisitors]);

  return {
    classVisitors,
    isLoading,
    error,
    reloadVisitors: loadVisitors,
  };
};
